export default function update() {
  if (process.env.NODE_ENV == 'development') console.log('track/update', window.location.href);
  if (window.Intercom) window.Intercom('update');
  if (window.Reamaze && window.Reamaze.reload) window.Reamaze.reload();
  if (window.ga) {
    window.ga(() => {
      // TODO check if this is the right tracker or send to all?
      let tracker = ga.getAll()[0];
      tracker.set('page', window.location.pathname);
      tracker.send('pageview');
    })
  }
  if (window.userpilot) window.userpilot.reload();
}



// WEBPACK FOOTER //
// ./src/lib/track/update.js